/** Shared section matching + Forecasts menu items for the desktop header and the mobile menu. */

export type SiteNavSection = "map" | "field-guide" | "experiences" | "forecasts";

export type ForecastMenuItem = {
  label: string;
  path: string;
  section: "forecasts";
};

const SECTION_PREFIXES: Record<SiteNavSection, string[]> = {
  map: ["/maps", "/map"],
  "field-guide": ["/field-guide"],
  experiences: ["/events", "/find", "/guides", "/hosts"],
  forecasts: ["/fall", "/forecast"],
};

function matchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * With `exactPath`, matches that one menu destination; otherwise matches any
 * page in the section.
 */
export function isSiteNavSectionActive(
  pathname: string,
  section: SiteNavSection,
  exactPath?: string,
): boolean {
  if (exactPath) return matchesPrefix(pathname, exactPath);
  return SECTION_PREFIXES[section].some((prefix) => matchesPrefix(pathname, prefix));
}

export function getForecastMenuItems(forecastEnabled: boolean): ForecastMenuItem[] {
  const items: ForecastMenuItem[] = [
    { label: "Fall Color", path: "/fall", section: "forecasts" },
  ];
  if (forecastEnabled) {
    items.push({ label: "Upland gamebirds", path: "/forecast/upland", section: "forecasts" });
  }
  return items;
}
